import React, { useEffect, useRef, useState } from 'react';
import { useEvent } from 'react-use';
import { useDebouncedCallback } from 'use-debounce';
import useResizeObserver from 'use-resize-observer';
import { useResolve } from '../../Container';
import { Flexer } from '../../dashboard/elements/LayoutElements';
import { Overlay } from './Overlay';
import { OverlayComposition } from './OverlayComposition';

export const OverlayLayer = React.memo(() => {

    const overlays = useResolve(OverlayComposition);
    const layer = useRef<HTMLDivElement>();
    const [ticker, setTicker] = useState(0);

    const reset = () => setTicker(-1);
    const requestTick = useDebouncedCallback(() => setTicker(x => x + 1), 200, { trailing: true });

    useResizeObserver({
        ref: layer, onResize: () => requestTick()
    });

    useEvent('resize', () => {
        reset();
        requestTick();
    });

    useEffect(() => overlays.observe(() => requestTick()), []);

    return <Flexer id="overlay-layer" ref={layer} inset pointerOff zIndex="1">
        {ticker >= 0 && layer.current && overlays.map(x =>
            !x.destroyed() && <OverlayMount
                key={x.id}
                overlay={x}
                ticker={ticker}
                width={layer.current.clientWidth}
                height={layer.current.clientHeight} />
        )}
    </Flexer>;
});

const OverlayMount: React.FC<{ overlay: Overlay, ticker: number, width: number, height: number }> =
    ({ overlay, ticker, width, height }) => {

        const styling = { display: 'block', position: 'absolute', left: 0, top: 0, } as any;
        const [elmt, setElmt] = useState(null as HTMLCanvasElement | null);

        useEffect(() => {
            if (!elmt) return;
            overlay.connect(elmt);
            return () => overlay.disconnect();
            // eslint-disable-next-line
        }, [elmt, ticker, width, height]);

        return <canvas style={styling} ref={setElmt} {...{ width, height }} />;
    };
